import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Plus } from 'lucide-react';
import CreateManagerModal from '../CreateManagerModal';
import styles from './Manager.module.scss';
import { commonGridStyles } from 'styles/gridStyles';
import { formatDate } from 'utils/date';
import commonStyles from 'styles/common.module.scss';

const Manager: React.FC = () => {
  const [createModalOpen, setCreateModalOpen] = useState(false);

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 70, align: 'center', headerAlign: 'center' },
    { field: 'userName', headerName: 'User Name', width: 120, align: 'left', headerAlign: 'left' },
    {
      field: 'email',
      headerName: 'email',
      width: 120,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <span className={`${styles.priority} ${styles[params.value?.toLowerCase()]}`}>
          {params.value}
        </span>
      ),
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 120,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <span className={`${styles.status} ${styles[params.value?.toLowerCase()]}`}>
          {params.value}
        </span>
      ),
    },
    {
      field: 'createdAt',
      headerName: 'Created At',
      width: 200,
      align: 'left',
      headerAlign: 'left',
      valueFormatter: (value) => formatDate(value),
    },
  ];

  const rows: any[] = []; // Empty table as requested

  return (
    <Box
      className={styles.supportContainer}
      sx={{
        height: 'calc(100vh - 48px)',
        overflow: 'hidden',
      }}
    >
      <Box className={styles.header}>
        <Typography variant="h4" className={styles.title}>
          Managers
        </Typography>
        <Box className={styles.controls}>
          <Button
            variant="contained"
            className={styles.createBtn}
            startIcon={<Plus size={18} />}
            onClick={() => {
              setCreateModalOpen(true);
            }}
          >
            Create Manager
          </Button>
        </Box>
      </Box>

      <CreateManagerModal open={createModalOpen} onClose={() => setCreateModalOpen(false)} />

      <Box className={commonStyles.gridWrapper}>
        <DataGrid
          rows={rows}
          columns={columns}
          sx={{
            ...commonGridStyles,
            mt: 6,
          }}
        />
      </Box>
    </Box>
  );
};

export default Manager;
